import Routing from 'src/routes';

const App = () => {
  return <Routing />;
};

export default App;
